export default {
  userProfile: { isAuthenticated: false, token: '', user: {} },
  appStatus: { loading: null },
}
